const KOREA_TIME_ZONE = "Asia/Seoul";
const EXPLICIT_TIME_ZONE_PATTERN = /(?:Z|[+-]\d{2}:?\d{2})$/i;
const TIME_PORTION_PATTERN = /T\d{2}:\d{2}/;

function parseDateTime(value, sourceTimeZone = "utc") {
  if (!value) return null;
  if (value instanceof Date) return value;

  const text = String(value ?? "").trim();
  if (!text) return null;

  const normalized = text.replace(/\s+/, "T");
  const dateInput =
    TIME_PORTION_PATTERN.test(normalized) &&
    !EXPLICIT_TIME_ZONE_PATTERN.test(normalized)
      ? sourceTimeZone === "kst"
        ? `${normalized}+09:00`
        : `${normalized}Z`
      : normalized;
  const date = new Date(dateInput);

  return Number.isNaN(date.getTime()) ? null : date;
}

export function parseUtcDateTime(value) {
  return parseDateTime(value, "utc");
}

export function parseKoreanDateTime(value) {
  return parseDateTime(value, "kst");
}

export function formatKoreanDateTime(value, options = {}) {
  if (!value) return "-";

  const { sourceTimeZone = "utc", ...dateTimeOptions } = options;
  const date = parseDateTime(value, sourceTimeZone);
  if (!date) return String(value);

  return new Intl.DateTimeFormat("ko-KR", {
    timeZone: KOREA_TIME_ZONE,
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    ...dateTimeOptions,
  }).format(date);
}
